import React, {useEffect, useState} from "react";
import associateServices from "../../../../services";
import TableFooter from "../../../../components/table-footer/TableFooter";
import moment from "moment";
import Big from "big.js";

const RacesHistory = props => {

    const {username} = props
    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [limit] = useState(10)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(true)

    useEffect(() => {

        associateServices.getRaceHistory({
            page, limit,username
        }).then(res => {
            setData(res?.data?.data || [])
            setTotal(res?.data?.total || 0)
            setLoading(false)
        })
    }, [page, limit])

    const handlePrev = () => {
        setPage(prevState => prevState <= 1 ? 1 : prevState - 1)
    }
    const handleNext = () => {
        setPage(prevState => prevState + 1)
    }

    if (!loading && data?.length <= 0)
        return null;

    return (
        <div className="col-12">
            <div className="table-responsive">
                <table className="xtable xtable--modal">
                    <thead>
                    <tr>
                        <th>Raffle name</th>
                        <th>Date</th>
                        <th>Position</th>
                        <th>Prize</th>
                    </tr>
                    </thead>
                    <tbody>
                    {

                        data?.map(race => (
                            <tr key={race?.id}>
                                <td>
                                    <div className="xtable__text">{race?.race?.key}</div>
                                </td>
                                <td>
                                    <div className="xtable__text">
                                        {moment.unix(race?.race?.end).format('MMM Do YY')}
                                    </div>
                                </td>
                                <td>
                                    <div className="xtable__text">
                                        {
                                            Big(race?.order_sort || 0).toFixed(2)
                                        }
                                    </div>
                                </td>
                                <td>
                                    <div className="xtable__text xtable__text--green">
                                        ${
                                        Big(race?.prize || 0).toFixed(2)
                                    }
                                    </div>
                                </td>
                            </tr>

                        ))
                    }

                    </tbody>
                </table>
            </div>

            {
                total > 0 &&
                <TableFooter
                    total={total}
                    limit={limit}
                    handlePrev={handlePrev}
                    handleNext={handleNext}
                    page={page}
                    buttonText={null}/>
            }
        </div>


    )

}

export default RacesHistory
